export default __webpack_public_path__ + "static/media/presentation.af495d4a.jpg";